// libs
import React, { memo } from 'react';
import { styled } from '@nykaa/ui-components';

// global components

// constants
import { DWEB_DISCOUNT_HEIGHT, DWEB_HEADER_HEIGHT } from 'shared/styles/base';

// styles

const Discount = styled.div`
  height: ${DWEB_DISCOUNT_HEIGHT}px;
  background: #000;
`;

const Menu = styled.div`
  height: ${DWEB_HEADER_HEIGHT}px;
  position: relative;

  .logo {
    position: absolute;
    left: 30px;
    top: 50%;
    display: block;
    transform: translateY(-50%);
  }
`;

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 80%;
  box-shadow: 0 1px 0 0 #ccc;
  z-index: 2;
  background: #fff;
`;

function Placeholder() {
  return (
    <Container>
      <Discount />
      <Menu />
    </Container>
  );
}

export default memo(Placeholder);
